import e from"styled-components";const o=e.div`
	display: flex;
	flex-direction: column;
	background-color: ${({theme:e})=>e.bg.general};
	height: 100%;
`;export{o as EditorContainer};
